import { z } from 'zod'

const subscriberCounts = z.object({
  clientsSms: z.number(),
  clientsEmail: z.number(),
})

const outreachClientCountsSchema = z.object({
  clients: z.object({
    clients: z.number(),
    email: subscriberCounts,
    prioSmsEmail: subscriberCounts,
    sms: subscriberCounts,
  }),
})

export { outreachClientCountsSchema }
